import { createClient, createConfig } from "@hey-api/client-fetch";
const client = createClient(
  createConfig({
    baseUrl: "http://localhost:3000"
  })
);
export {
  client
};
//# sourceMappingURL=client.gen.js.map